import { useNavContext } from 'context/nav-context'
import { useCallback, useEffect, useRef } from 'react'

export const useSectionObserver = () => {
  const { setVisibleItem, items, setItems } = useNavContext()
  const observer = useRef<IntersectionObserver>()

  useEffect(() => {
    observer.current = new IntersectionObserver(
      entries => {
        const visible = entries.find(entry => entry.isIntersecting)?.target as
          | HTMLElement
          | undefined

        if (visible) {
          setVisibleItem(visible)
        }
      },
      { rootMargin: '-50% 0px -50% 0px' }
    )

    items.forEach(item => {
      observer.current?.observe(item)
    })

    return () => {
      observer.current?.disconnect()
    }
  }, [items])

  const addItem = useCallback((el: HTMLElement | null) => {
    if (el) {
      const h2 = el.querySelector('h2')

      if (!el.getAttribute('data-title') && h2) {
        el.setAttribute(
          'data-title',
          (h2?.getAttribute('data-menu-title') || h2!.textContent) as string
        )
      }

      observer.current?.observe(el)
      setItems(v =>
        v.find(
          i =>
            i.getAttribute('data-title') === el.querySelector('h2')?.textContent
        )
          ? v
          : [...v, el]
      )
    }
  }, [])

  return { addItem }
}
